<template>
    <div class="app-shell">
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200" />
        <nav class="navbar" role="navigation" aria-label="main navigation">
            <div class="navbar-brand">

                <!-- The logo, 44px high and centred in the bar, as the design has it. It goes home, as
                     Ana Sayfa does (with the same question when a project is open); it used to open
                     EAE's product page in a new tab. -->
                <a class="brand-logo" href="/" @click.prevent="openMainPage()">
                    <img src="/img/E-kabin logo.jpg" alt="E-Kabin" />
                </a>

                <span class="brand-divider" aria-hidden="true"></span>
                <div class="navbar-start">
                    <!-- As the design writes it: the product name in bold, then what it is. On a
                         phone the two go on two lines (EAE's request, not the design's). -->
                    <div class="brand-text">
                        <span class="brand-name">PanelTemp</span> <span class="brand-title">{{ $lang.Menus.ProjectTitle }}</span>
                    </div>
                </div>

                <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" data-target="navMenu">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </a>


            </div>

            <div id="navMenu" class="navbar-menu">


                <div class="navbar-end">
                    <!--<router-link to="/" class="navbar-item">{{ this.$lang.Menus.MainPage }}</router-link>-->
                    <div class="navbar-item" style="padding: 0rem;">
                        <b-button @click="openMainPage()" class="customNavbarBtn">{{ this.$lang.Menus.MainPage }}</b-button>
                    </div>
                    <div class="navbar-item" style="padding: 0rem">
                        <b-button @click="openNewProject()" class="customNavbarBtn">{{ this.$lang.Menus.NewProject }}</b-button>
                    </div>
                    <div class="navbar-item" style="padding: 0rem" v-if="this.$store.state.memberId != 'TestMember'">
                        <b-button @click="openMyProjects()" class="customNavbarBtn">{{ this.$lang.Menus.MyProjects }}</b-button>
                    </div>
                    <!--
                        Admin pages. On a desktop they sit under one Admin menu, as in the design
                        - seven buttons did not fit the bar at 1280px once the type grew. In the
                        burger menu they stay a flat list. Devre Cihazları is a plain item for
                        members and joins the Admin menu for admins.
                    -->
                    <div class="navbar-item is-hidden-touch" style="padding: 0rem" v-if="this.$store.state.memberId != 'TestMember' && this.$store.state.isAdmin == 1">
                        <b-dropdown class="admin-menu" position="is-bottom-left">
                            <template #trigger="{ active }">
                                <button type="button" class="nav-chip is-admin" :class="{ 'is-open': active }">
                                    {{ $lang.Menus.Admin }}
                                    <span :class="['mdi', active ? 'mdi-chevron-up' : 'mdi-chevron-down']" aria-hidden="true"></span>
                                </button>
                            </template>
                            <b-dropdown-item @click="openAllProjects()">{{ $lang.Menus.AllProjects }}</b-dropdown-item>
                            <b-dropdown-item @click="openCircuitDevices()">{{ $lang.Menus.CircDevices }}</b-dropdown-item>
                            <b-dropdown-item @click="openAcceptLogs()">{{ $lang.Menus.Logs }}</b-dropdown-item>
                            <b-dropdown-item @click="openMembers()">{{ $lang.Menus.Users }}</b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div class="navbar-item is-hidden-desktop" style="padding: 0rem" v-if="this.$store.state.memberId != 'TestMember' && this.$store.state.isAdmin == 1">
                        <b-button @click="openAllProjects()" class="customNavbarBtn">{{ this.$lang.Menus.AllProjects }}</b-button>
                    </div>
                    <div class="navbar-item" :class="{ 'is-hidden-desktop': this.$store.state.isAdmin == 1 }" style="padding: 0rem" v-if="this.$store.state.memberId != 'TestMember'">
                        <b-button @click="openCircuitDevices()" class="customNavbarBtn">{{ this.$lang.Menus.CircDevices }}</b-button>
                    </div>
                    <div class="navbar-item is-hidden-desktop" style="padding: 0rem" v-if="this.$store.state.memberId != 'TestMember' && this.$store.state.isAdmin == 1">
                        <b-button @click="openAcceptLogs()" class="customNavbarBtn">{{ this.$lang.Menus.Logs }}</b-button>
                    </div>
                    <div class="navbar-item is-hidden-desktop" style="padding: 0rem" v-if="this.$store.state.memberId != 'TestMember' && this.$store.state.isAdmin == 1">
                        <b-button @click="openMembers()" class="customNavbarBtn">{{ this.$lang.Menus.Users }}</b-button>
                    </div>
                    <div class="navbar-item" style="padding: 0rem">
                        <!-- The chip names the language you would switch to, as in the design. -->
                        <b-dropdown v-model="selectedLanguage" class="langsymbol" position="is-bottom-left" @change="setLanguage">
                            <template #trigger="{ active }">
                                <button type="button" class="lang-chip" :class="{ 'is-open': active }">
                                    <span class="mdi mdi-web" aria-hidden="true"></span>
                                    {{ selectedLanguage == 'TR' ? 'EN' : 'TR' }}
                                    <span :class="['mdi', active ? 'mdi-chevron-up' : 'mdi-chevron-down']" aria-hidden="true"></span>
                                </button>
                            </template>
                            <b-dropdown-item v-for="option in langlist" :key="option.code" :value="option.code">
                                {{ option.label }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div class="navbar-item registerbutton" style="padding-left: 0.5rem">
                        <!--<router-link v-if="this.$store.state.memberId == 'TestMember'" to="/AddMember" class="button is-warning">
                            <b-icon icon="account" type="is-primary" size="is-small"></b-icon>{{ this.$lang.Login.SignUpBtn }}
                        </router-link>-->
                        <!-- Text only, as in the design (the user icon it had is not drawn there). -->
                        <b-button v-if="this.$store.state.memberId == 'TestMember'" class="button is-warning" @click="openSignUp()">
                            {{ this.$lang.Login.SignUpBtn }}
                        </b-button>
                    </div>
                    <div class="navbar-item" style="padding-left: 0.5rem">
                        <!--<router-link :to="openSignIn()" class="button is-white">
                            <b-icon v-if="this.$store.state.memberId == 'TestMember'" icon="login" type="is-primary" size="is-small"></b-icon>
                            <b-icon v-if="this.$store.state.memberId != 'TestMember'" icon="account" type="is-primary" size="is-small"></b-icon>
                            {{ this.signInBtnText }}
                        </router-link>-->
                        <!-- Signed in: the member's name in an outlined chip, as the design draws it. -->
                        <b-button class="button is-white" :class="{ 'user-chip': this.$store.state.memberId != 'TestMember' }" @click="openSignIn()">
                            <b-icon v-if="this.$store.state.memberId == 'TestMember'" icon="login" type="is-primary" size="is-small"></b-icon>
                            <b-icon v-if="this.$store.state.memberId != 'TestMember'" icon="account" type="is-primary" size="is-small"></b-icon>
                            {{ this.signInBtnText }}
                        </b-button>

                        <b-button class="customNavbarBtn logout-btn" v-if="this.$store.state.memberId != 'TestMember'" :title="$lang.Login.LogoutBtn" :aria-label="$lang.Login.LogoutBtn" @click="logout">
                            <span class="mdi mdi-logout" aria-hidden="true"></span>

                            <!--<span>{{ this.$lang.Login.LogoutBtn }}</span>-->
                        </b-button>
                    </div>
                    <!--<div class="navbar-item" style="padding-left: 0rem; padding-top: 0rem; padding-bottom: 0rem; padding-right: 0.5rem; ">
                    <b-button class="customNavbarBtn" v-if="this.$store.state.memberId != 'TestMember'" title="Log out" @click="logout">
                        <b-icon icon="logout" style="padding-top: 1rem; padding-left: 1rem" />-->
                    <!--<span>{{ this.$lang.Login.LogoutBtn }}</span>-->
                    <!--</b-button>
                    </div>-->
                </div>
            </div>
        </nav>
        <slot></slot>
        <footer-bar />
    </div>
</template>

<script>
    import FooterBar from '@/components/FooterBar.vue';
    import router, { PRE_REPORT_PATHS } from '@/router';
    // import api from '@/api';

    export default {
        name: 'Main',
        components: {
            FooterBar
        },
        data() {
            return {
                signInBtnText: this.$lang.Login.LoginBtn,
                selectedLanguage: '',
                langlist: [
                    { code: "TR", label: "Türkçe" },
                    { code: "EN", label: "English" }
                ]
            }
        },
        mounted() {
            // A new browser session without "Beni Hatırla" starts signed out. It cleared only
            // userInfo, leaving the rest of the sign-in in the saved store.
            if (!this.$store.state.rememberMe && sessionStorage.getItem('isOpenedFirstTime') == null) {
                if (this.$store.state.token) {
                    this.$store.commit('logout');
                } else {
                    this.$store.state.userInfo = {};
                }
                sessionStorage.setItem('isOpenedFirstTime', 'true');
            }

            if (this.$store.state.userInfo.Id != null) {
                this.$store.state.memberId = this.$store.state.userInfo.Id;
                this.$store.state.isAdmin = this.$store.state.userInfo.IsAdmin;
                this.signInBtnText = this.$store.state.userInfo.Name;
            } else {
                this.$store.state.memberId = 'TestMember';
                this.signInBtnText = this.$lang.Login.LoginBtn;
            }

            if (this.$config.lang == "tr-TR") {
                this.selectedLanguage = "TR"
            } else if (this.$config.lang == "en-EN") {
                this.selectedLanguage = "EN"
            }

            const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);
            $navbarBurgers.forEach(el => {
                el.addEventListener('click', () => {
                    const target = el.dataset.target;
                    const $target = document.getElementById(target);
                    el.classList.toggle('is-active');
                    $target.classList.toggle('is-active');
                });
            });
        },
        watch: {
            $route() {
                if (this.$store.state.userInfo.Id != null) {
                    this.$store.state.memberId = this.$store.state.userInfo.Id;
                    this.$store.state.isAdmin = this.$store.state.userInfo.IsAdmin;
                    this.signInBtnText = this.$store.state.userInfo.Name;
                } else {
                    this.$store.state.memberId = 'TestMember';
                    this.signInBtnText = this.$lang.Login.LoginBtn;
                }
            }
        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            }
        },
        methods: {
            /*
             * Every menu link goes through here. Leaving the wizard before Rapor loses the
             * project, so only then is there a warning. It used to follow projectId, which
             * viewing a report also sets and nothing clears: back on Projelerim after a
             * report, Projelerim warned about leaving a project that was not open. Nine
             * copies of that test looked at the current route in some places and at
             * previousRoute in others. The page you are on is not reloaded.
             */
            leaveTo(path, warning) {
                if (this.$route.path.toLowerCase() === path.toLowerCase()) {
                    return;
                }
                if (!PRE_REPORT_PATHS.includes(this.$route.path.toLowerCase())) {
                    router.push(path);
                    return;
                }
                const texts = warning || {
                    title: this.$lang.DeleteDialog.Title,
                    message: this.$lang.DeleteDialog.Message_2,
                    confirmText: this.$lang.DeleteDialog.Confirm_2,
                    cancelText: this.$lang.DeleteDialog.Cancel
                };
                this.$buefy.dialog.confirm({
                    ...texts,
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        // Signing in keeps the draft; anywhere else it is dropped.
                        if (!warning) {
                            this.$store.state.projectId = '';
                        }
                        router.push(path);
                    }
                });
            },
            loginWarning() {
                return {
                    title: this.$lang.LoginWarningDialog.Title,
                    message: this.$lang.LoginWarningDialog.Message,
                    confirmText: this.$lang.LoginWarningDialog.Confirm,
                    cancelText: this.$lang.LoginWarningDialog.Cancel
                };
            },
            openMainPage() {
                this.leaveTo('/');
            },
            openSignIn() {
                if (this.$store.state.memberId == 'TestMember') {
                    this.leaveTo('/LoginMember', this.loginWarning());
                } else {
                    this.$store.state.previousRoute = this.$route.name;
                    router.push('/UpdateMember');
                }
            },
            openSignUp() {
                if (this.$store.state.memberId == 'TestMember') {
                    this.leaveTo('/AddMember', this.loginWarning());
                } else {
                    router.push('/AddMember');
                }
            },
            logout() {
                this.$store.commit('logout', this.$lang.Login.LoginBtn);
                this.$store.state.memberId = 'TestMember';
                this.$store.state.cryptMember = [];
                this.$store.canReportPageOpen = false;
                this.signInBtnText = this.$lang.Login.LoginBtn;
                router.push('/');
            },
            setLanguage(code) {
                if (code) {
                    this.selectedLanguage = code;
                }
                if (this.selectedLanguage == "TR") {
                    this.$config.lang = "tr-TR";
                } else if (this.selectedLanguage == "EN") {
                    this.$config.lang = "en-EN";
                }
                this.$store.state.lang = this.$config.lang;
                window.localStorage.setItem("lang", this.$config.lang);
                window.location.reload();
            },
            openCircuitDevices() {
                this.$store.state.previousRoute = this.$route.name;
                this.$store.state.isCircDevicesFromCalculation = false;
                this.leaveTo(this.$store.state.isAdmin == 1 ? '/CircuitDevices_Admin' : '/CircuitDevices');
            },
            openAllProjects() {
                this.$store.state.previousRoute = this.$route.name;
                this.leaveTo('/AllProjects');
            },
            openNewProject() {
                this.leaveTo('/NewProject');
            },
            openMyProjects() {
                this.leaveTo('/MyProjects');
            },
            openAcceptLogs() {
                this.$store.state.previousRoute = this.$route.name;
                this.leaveTo('/AcceptLogs');
            },
            openMembers() {
                this.$store.state.previousRoute = this.$route.name;
                this.leaveTo('/Users');
            },
            deleteProject() {
                this.$store.state.isPrevProject = false;
            }
        }
    };
</script>

<style>
    .customNavbarBtn {
        background-color: transparent;
        border-color: transparent;
        color: #1d1d1d;
        font-size: 14px;
        font-weight: 400;
    }

    /* The focus ring after a mouse click stayed on the link until something else took
       focus, so the page just opened looked selected in the menu. The ring is for the
       keyboard: it still shows when the bar is reached with Tab. */
    .navbar .button:focus:not(:focus-visible),
    .navbar button:focus:not(:focus-visible) {
        box-shadow: none;
    }

        .customNavbarBtn:hover {
            background-color: #f7f7f7;
            border-color: transparent;
            color: #1d1d1d;
        }

        .customNavbarBtn:focus {
            background-color: #f7f7f7;
            border-color: transparent;
            color: #1d1d1d;
        }


    .langsymbol {
        margin-left: 2.5rem;
        margin-right: 0.5rem;
    }

    .lang-chip,
    .nav-chip {
        display: flex;
        align-items: center;
        gap: 6px;
        height: 34px;
        padding: 0 12px;
        border: 1px solid #c9c9c9;
        border-radius: 6px;
        background: transparent;
        color: #1d1d1d;
        font: inherit;
        font-size: 14px;
        cursor: pointer;
    }

        .lang-chip .mdi,
        .nav-chip .mdi {
            font-size: 16px;
            line-height: 1;
            color: #575757;
        }

        .lang-chip.is-open {
            border-color: #0060a0;
            background: #f7f7f7;
        }

        .nav-chip.is-admin {
            margin-left: 12px;
            font-weight: 600;
            background: #f7f7f7;
        }

        .nav-chip.is-admin.is-open {
            border-color: #0060a0;
            background: #e8f2f9;
            color: #0060a0;
        }

    @media only screen and (max-width: 1024px) {
        .langsymbol {
            margin-left: 0.5rem;
            margin-right: 0.5rem;
        }

        .registerbutton {
            padding-bottom: 0;
        }
    }

    .navbar-start {
        padding-left: 2rem;
        color: #575757;
        font-size: 14px;
        display: flex;
        align-items: center;
    }

    .navbar-brand {
        align-items: center;
    }

    .brand-logo {
        display: flex;
        align-items: center;
        align-self: stretch;
        padding: 0 16px 0 26px;
    }

    .brand-logo img {
        display: block;
        width: auto;
        height: 44px;
        max-height: none;
    }

    /* The thin rule between the logo and the product name. It goes with the name, which the
       bar drops below 1280px. */
    .brand-divider {
        width: 1px;
        height: 24px;
        margin: 0 0 0 0;
        background: #e3e3e3;
    }

    .navbar-brand .navbar-start {
        padding-left: 16px;
    }

    .navbar .button.user-chip {
        height: 34px;
        gap: 7px;
        padding: 0 11px;
        font-weight: 600;
        color: #1d1d1d;
        border: 1px solid #c9c9c9;
        border-radius: 6px;
    }

    .navbar .button.user-chip:hover,
    .navbar .button.user-chip:focus {
        background: #f7f7f7;
        border-color: #0060a0;
    }

    .navbar .button.user-chip .icon {
        margin: 0 !important;
    }

    .navbar .logout-btn .mdi {
        font-size: 26px;
        line-height: 1;
        color: #575757;
    }

    .navbar-start .brand-name {
        font-weight: 600;
        color: #1d1d1d;
    }

    /* Between 1024 and 1279px the full bar does not fit beside the product name, so the
       name goes. */
    @media screen and (min-width: 1024px) and (max-width: 1279px) {
        .navbar-brand .navbar-start,
        .brand-divider {
            display: none;
        }
    }

    /* The menu button as the design draws it on a phone: a 48px target with a 34px icon.
       Bulma's is a 16px icon in the bar's height. */
    @media screen and (max-width: 1023px) {
        /* The phone bar: 12px above and below the 48px menu button, 16px from the edge. */
        .navbar-brand {
            min-height: 72px;
        }

        .brand-logo {
            padding-left: 16px;
            padding-right: 12px;
        }

        /* The design shows only the logo here. EAE asked for the product name as well, so
           the visitor knows which site this is: two lines beside the logo. */
        .navbar-brand .navbar-start {
            min-width: 0;
            padding-left: 12px;
            font-size: 13px;
            line-height: 1.25;
        }

        .brand-text .brand-name,
        .brand-text .brand-title {
            display: block;
        }

        .brand-text .brand-name {
            font-size: 15px;
        }

        .navbar-burger {
            width: 48px;
            height: 48px;
            margin-right: 4px;
            color: #1d1d1d;
        }

        .navbar-burger:hover,
        .navbar-burger.is-active {
            color: #1d1d1d;
            background-color: transparent;
        }

        .navbar-burger span {
            left: calc(50% - 13px);
            width: 26px;
            height: 3px;
            border-radius: 1px;
        }

        .navbar-burger span:nth-child(1) { top: calc(50% - 10px); }
        .navbar-burger span:nth-child(2) { top: calc(50% - 1.5px); }
        .navbar-burger span:nth-child(3) { top: calc(50% + 7px); }

        .navbar-burger.is-active span:nth-child(1) { transform: translateY(8.5px) rotate(45deg); }
        .navbar-burger.is-active span:nth-child(3) { transform: translateY(-8.5px) rotate(-45deg); }
    }

    /* A narrow phone: a smaller logo leaves the name its two lines. */
    @media screen and (max-width: 420px) {
        .brand-logo {
            padding-left: 12px;
            padding-right: 10px;
        }

        .brand-logo img {
            height: 32px;
        }

        .navbar-brand .navbar-start {
            padding-left: 10px;
            font-size: 12px;
        }

        .brand-text .brand-name {
            font-size: 14px;
        }
    }

    .dialog .modal-card .modal-card-foot {
        justify-content: space-evenly;
    }
</style>
